/* Brasine 14/10 (retour Baptiste) : flèches précédente / suivante sur la grande image de la fiche, sur ordinateur.
   Elles passent par la galerie de Dawn (setActiveMedia), comme un clic sur une vignette, donc pas de saut de page. */
(function () {
  function brancher(galerie) {
    if (galerie.dataset.brasineFleches) return;
    var vignettes = galerie.querySelector('[id^="GalleryThumbnails"]');
    var visionneuse = galerie.querySelector('[id^="GalleryViewer"]');
    if (!vignettes || !visionneuse || typeof galerie.setActiveMedia !== 'function') return;
    var cibles = Array.prototype.slice.call(vignettes.querySelectorAll('[data-target]'));
    if (cibles.length < 2) return;
    galerie.dataset.brasineFleches = '1';
    function aller(pas) {
      var actuelle = cibles.findIndex(function (c) { return c.querySelector('[aria-current="true"]'); });
      if (actuelle < 0) actuelle = 0;
      var suivante = (actuelle + pas + cibles.length) % cibles.length;
      galerie.setActiveMedia(cibles[suivante].dataset.target, false);
    }
    [['precedente', -1, 'Photo précédente', 'M15 5l-7 7 7 7'], ['suivante', 1, 'Photo suivante', 'M9 5l7 7-7 7']].forEach(function (f) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'brasine-fleche brasine-fleche--' + f[0];
      b.setAttribute('aria-label', f[2]);
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + f[3] + '" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
      b.addEventListener('click', function (e) { e.preventDefault(); aller(f[1]); });
      visionneuse.appendChild(b);
    });
  }
  function tout() { document.querySelectorAll('media-gallery[data-desktop-layout*="thumbnail"]').forEach(brancher); }
  /* media-gallery.js est chargé après ce fichier : on attend que l'élément soit défini. */
  function demarrer() { if (window.customElements) customElements.whenDefined('media-gallery').then(tout); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();

  /* 22/10 (remarque 5 de Baptiste) : les photos 2 et suivantes sont en loading="lazy" et cachées, donc téléchargées
     seulement au premier clic (0,4 à 0,7 s d'attente). Une fois la page chargée, on les précharge en arrière-plan. */
  function precharger() {
    document.querySelectorAll('media-gallery [id^="GalleryViewer"] img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });
    /* Photos des autres variantes (absentes de la galerie tant qu'on ne les choisit pas) : même srcset et même sizes
       que la galerie, pour que le navigateur prenne la même largeur et la serve depuis son cache au clic. */
    var modele = document.querySelector('media-gallery [id^="GalleryViewer"] img');
    window.brasinePrecharges = window.brasinePrecharges || [];
    document.querySelectorAll('label[data-precharge]').forEach(function (label) {
      var img = new Image();
      img.sizes = modele ? modele.sizes : '100vw';
      img.srcset = label.dataset.precharge;
      window.brasinePrecharges.push(img);
    });
  }
  function apresChargement() {
    if (window.requestIdleCallback) requestIdleCallback(precharger, { timeout: 2000 }); else setTimeout(precharger, 1000);
  }
  if (document.readyState === 'complete') apresChargement(); else window.addEventListener('load', apresChargement);
})();
